import { AGENT_TIER_LABEL_KEYS, type DisplayTierName } from '~/constants/agentTiers';

/**
 * Localized agent-tier display names. Tier ids (STARTER, ELITE, …) stay
 * English everywhere else (comparisons, payloads, analytics); only the
 * rendered label goes through `t()`.
 */
export const useAgentTierLabel = () => {
  const { t } = useI18n();

  const tierLabel = (tier: string | null | undefined): string => {
    if (!tier) return '';
    const key = AGENT_TIER_LABEL_KEYS[tier as DisplayTierName];
    return key ? t(key) : tier;
  };

  return {
    tierLabel,
  };
};
